import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard, authGuardLanding, revAuthGuard } from './utility/guard/auth.guard';
import { ROUTE_CONFIGS } from './utility/configs/routerConfig';
import { FaqsComponent } from './utility/faqs/faqs/faqs.component';

const routes: Routes = [
  { path: 'authentication', loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule) },
  { path: 'customer', canActivate: [authGuard], loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule) },
  { path: ROUTE_CONFIGS.FAQS, component: FaqsComponent },
  { path: '', canActivate: [authGuardLanding], loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule), pathMatch: 'full' },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
